import { Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LucideAngularModule, Download, X } from 'lucide-angular';
import { PwaInstallService } from '@stockflow/offline-core';
import { TranslationService } from '../../../core/services/translation.service';

const DISMISS_KEY = 'stockflow.pwa-install-dismissed';

/**
 * MOB-014 — bandeau d'installation, monté une seule fois dans
 * MainLayoutComponent (comme `<app-call-overlay>`) : visible dès la première
 * connexion, tant que `beforeinstallprompt` a été capté et que la caissière
 * ne l'a pas déjà écarté sur ce poste.
 */
@Component({
    selector: 'app-pwa-install-banner',
    standalone: true,
    imports: [LucideAngularModule],
    templateUrl: './pwa-install-banner.component.html',
})
export class PwaInstallBannerComponent {
    private pwaInstall = inject(PwaInstallService);
    private platformId = inject(PLATFORM_ID);
    translationService = inject(TranslationService);
    t = this.translationService.t;

    readonly Download = Download;
    readonly X = X;

    canInstall = this.pwaInstall.canInstall;
    private readonly _dismissed = signal(this.wasDismissed());
    dismissed = this._dismissed.asReadonly();

    async install() {
        await this.pwaInstall.promptInstall();
    }

    dismiss() {
        this._dismissed.set(true);
        if (!isPlatformBrowser(this.platformId)) return;
        try {
            localStorage.setItem(DISMISS_KEY, '1');
        } catch {
            /* stockage indisponible (navigation privée) — le bandeau reviendra au prochain chargement, sans conséquence */
        }
    }

    private wasDismissed(): boolean {
        if (!isPlatformBrowser(this.platformId)) return false;
        try {
            return localStorage.getItem(DISMISS_KEY) === '1';
        } catch {
            return false;
        }
    }
}
